var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form',{ref:_vm.refName,attrs:{"model":_vm.model,"label-width":_vm.labelWidth,"rules":_vm.rules}},[_vm._t("default"),(_vm.showButton)?_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v(_vm._s(_vm.submitText))])],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }